import { Injectable } from '@angular/core';
import Quill from 'quill';

@Injectable({
  providedIn: 'root'
})
export class CustomClipboardService {
  static getCustomClipboardClass(): unknown {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ClipboardModule = Quill.import('modules/clipboard') as any;

    return class CustomClipboard extends ClipboardModule {
      onCopy(range: unknown, isCut: boolean): { html: string; text: string } {
        const result = super.onCopy(range, isCut) as { html: string; text: string };
        result.html = this.sanitizeHtmlForEmDashes(result.html);
        result.text = this.sanitizeText(result.text);
        return result;
      }

      private sanitizeText(text: string): string {
        if (!text) return text;

        let sanitized = text
          // Remove zero-width characters
          .replace(/\u200B/g, '')  // zero-width space
          .replace(/\u200C/g, '')  // zero-width non-joiner
          .replace(/\u00AD/g, '')  // soft hyphen
          .replace(/\u200D/g, '')  // zero-width joiner
          .replace(/\u2060/g, ''); // word joiner

        // Remove newlines that appear after hyphens (for compound words)
        // Handles \n, \r\n, and multiple whitespace/newlines combinations
        sanitized = sanitized.replace(/-\s*[\r\n]+/g, '-');

        return sanitized;
      }

      private sanitizeHtmlForEmDashes(html: string): string {
        if (!html) return html;

        let sanitized = html
          // Remove zero-width characters
          .replace(/\u200B/g, '')  // zero-width space
          .replace(/\u200C/g, '')  // zero-width non-joiner
          .replace(/\u00AD/g, '')  // soft hyphen
          .replace(/\u200D/g, '')  // zero-width joiner
          .replace(/\u2060/g, '')  // word joiner
          // Remove word break tags
          .replace(/<wbr\s*\/?>/gi, '');

        // Remove empty spans around em dashes
        sanitized = sanitized.replace(/<span([^>]*)>\s*(\u2014|&mdash;|&#8212;)\s*<\/span>/gi, '\u2014');

        // Remove line breaks after em dashes and regular hyphens (including HTML entities)
        // Matches: -, &#45;, &hyphen; followed by optional whitespace and <br> tags
        sanitized = sanitized.replace(/(\u2014|&mdash;|&#8212;|-|&#45;|&hyphen;)\s*(<br\s*\/?>)/gi, '$1');

        // Also handle cases where closing tags might be between hyphen and br
        // e.g., "Counter-</span><br><span>Strike" -> "Counter-</span><span>Strike"
        sanitized = sanitized.replace(/(-|&#45;|&hyphen;)(<\/[^>]+>)\s*(<br\s*\/?>)/gi, '$1$2');

        return sanitized;
      }
    };
  }
}
